import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { useNavigate } from "react-router-dom";
import TablePagination from "./TablePagination";
import StandardDatePicker from "./StandardDatePicker";

const BackEndReportLayer = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    expoName: null,
    backEnd: null,
    fromDate: "",
    toDate: "",
  });

  const [reportData, setReportData] = useState([
    { _id: "1", companyName: "Tech Solutions", status: "Completed", keyPerson: "Alice Green", mobileNumber: "9876543210", backEnd: "Backend User 1", remarks: "Good followed up", otherRemarks: "N/A", callHistory: "3 calls" },
    { _id: "2", companyName: "Logistics Pro", status: "Pending", keyPerson: "Bob White", mobileNumber: "9876543211", backEnd: "Backend User 2", remarks: "Busy, call later", otherRemarks: "N/A", callHistory: "1 call" },
  ]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalRecords, setTotalRecords] = useState(2);

  const expoOptions = [
    { value: "expo1", label: "Global Trade Fair 2026" },
    { value: "expo2", label: "Tech Expo 2026" },
  ];

  const backEndOptions = [
    { value: "backend1", label: "Alice (Support)" },
    { value: "backend2", label: "Bob (Operations)" },
  ];

  const handleSelectChange = (selectedOption, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: selectedOption,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div
        className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
        style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}
      >
        <h6 className="text-white pb-2 mb-0 uppercase tracking-wider">BACK END REPORT</h6>
        {/* <button 
            onClick={() => navigate(-1)} 
            className="btn btn-sm d-flex align-items-center gap-2 text-white" 
            style={{ backgroundColor: "rgba(255,255,255,0.2)", border: "1px solid white" }}
        >
            <Icon icon="solar:alt-arrow-left-bold" />
            Back
        </button> */}
      </div>
      <div className="card-body p-24">
        <div
          className="p-24 radius-12 mb-24"
          style={{ backgroundColor: "#f7e7da" }}
        >
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label fw-semibold text-secondary-light">
                Expo Name :
              </label>
              <Select
                options={expoOptions}
                styles={selectStyles()}
                value={formData.expoName}
                onChange={(opt) => handleSelectChange(opt, "expoName")}
                placeholder="-- Select --"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold text-secondary-light">
                Back Ends :
              </label>
              <Select
                options={backEndOptions}
                styles={selectStyles()}
                value={formData.backEnd}
                onChange={(opt) => handleSelectChange(opt, "backEnd")}
                placeholder="-- Select --"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold text-secondary-light">
                From Date :
              </label>
              <StandardDatePicker
                name="fromDate"
                value={formData.fromDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold text-secondary-light">
                To Date :
              </label>
              <StandardDatePicker
                name="toDate"
                value={formData.toDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-12 d-flex justify-content-end gap-3 mt-16">
              <button
                type="button"
                className="btn btn-primary-600 px-32 py-10 radius-8 h-40-px"
              >
                Search
              </button>
              <button
                type="button"
                className="btn btn-warning px-24 py-10 radius-8 d-flex align-items-center gap-2 h-40-px"
                style={{ backgroundColor: "#ed1c24", border: "none" }}
              >
                <Icon icon="solar:printer-bold" className="text-xl" />
                PRINT
              </button>
            </div>
          </div>
        </div>

        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr style={{ backgroundColor: "#f7e7da" }}>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>S.No</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Company Name</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Status</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Key Person</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Mobile Number</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Back End</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Remarks</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Other Remarks</th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>Call History</th>
              </tr>
            </thead>
            <tbody>
              {reportData.length > 0 ? (
                reportData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.companyName}</td>
                    <td>{item.status}</td>
                    <td>{item.keyPerson}</td>
                    <td>{item.mobileNumber}</td>
                    <td>{item.backEnd}</td>
                    <td>{item.remarks}</td>
                    <td>{item.otherRemarks}</td>
                    <td>{item.callHistory}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-24 text-secondary-light font-medium">
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <TablePagination
          currentPage={currentPage}
          totalPages={Math.ceil(totalRecords / rowsPerPage)}
          onPageChange={(page) => setCurrentPage(page)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(0);
          }}
          totalRecords={totalRecords}
        />
      </div>
    </div>
  );
};

export default BackEndReportLayer;


